import ChapterScreen from "./pages/coursesManagement/screen/ChapterScreen";
import SubTopicScreen from "./pages/coursesManagement/screen/SubTopicScreen";
import TopicScreen from "./pages/coursesManagement/screen/TopicScreen";
import LayoutBuilder from "./components/Layout/LayoutBuilder";
import AssignmentScreen from "./pages/assignmentManagement/screen/AssignmentScreen";
import SubjectScreen from "./pages/coursesManagement/screen/SubjectScreen";
import LoginScreen from "./pages/adminlogin/LoginScreen";
import CoursesScreen from "./pages/coursesManagement/screen/CoursesScreen";
import ClassScheduleScreen from "./pages/scheduleAndTimetable/screens/ClassScheduleScreen";
import TimetableScreen from "./pages/scheduleAndTimetable/screens/TimetableScreen";
// import TeacherInfoScreen from "./pages/teacherManagement/screen/TeacherInfoScreen";
import PackageScreen from "./pages/packageManagement/screen/PackageScreen";
import AllTeacherScreen from "./pages/teacherManagement/screen/AllTeacherScreen";
const publicRoutes = [
  {
    name: "Login",
    path: "/",
    component: <LoginScreen />,
  },
  //   {
  //     name: "Auth Loading",
  //     path:
  //       process.env.REACT_APP_ENVIRON === "production"
  //         ? "/auth/:unique_id"
  //         : "/auth/:secret_token",
  //     component: <AuthLoading message={"Trying to Logging you in..."} />,
  //   },
  //   {
  //     name: "Auth Loading",
  //     path: "/auth",
  //     component: <AuthLoading message={"Logging you in..."} />,
  //   },
];

const privateRoutes = [

   {
    name: "Teacher Overview",
    path: "/teacher-overview",
    component: (
      <LayoutBuilder>
        <AllTeacherScreen />
      </LayoutBuilder>
    ),
  },
  {
    name: "Subject",
    path: "/subjects",
    component: (
      <LayoutBuilder>
        <SubjectScreen />
      </LayoutBuilder>
    ),
  },
  {
    name: "Chapter",
    path: "/chapters",
    component: (
      <LayoutBuilder>
        {" "}
        <ChapterScreen />
      </LayoutBuilder>
    ),
  },
  {
    name: "Topics",
    path: "/topics",
    component: (
      <LayoutBuilder>
        <TopicScreen />,
      </LayoutBuilder>
    ),
  },

  {
    name: "Sub Topics",
    path: "/sub-topics",
    component: (
      <LayoutBuilder>
        <SubTopicScreen />{" "}
      </LayoutBuilder>
    ),
  },

  {
    name: "My Courses",
    path: "/courses",
    component: (
      <LayoutBuilder>
        <CoursesScreen />
      </LayoutBuilder>
    ),
  },

  {
    name: "Class Schedule",
    path: "/class-schedule",
    component: (
      <LayoutBuilder>
        <ClassScheduleScreen />
      </LayoutBuilder>
    ),
  },

  {
    name: "Time table",
    path: "/time-table",
    component: (
      <LayoutBuilder>
        <TimetableScreen />
      </LayoutBuilder>
    ),
  },

  {
    name: "Assignment",
    path: "/assignment",
    component: (
      <LayoutBuilder>
        <AssignmentScreen />
      </LayoutBuilder>
    ),
  },

  {
    name: "Packages",
    path: "/packages",
    component: (
      <LayoutBuilder>
        <PackageScreen />
      </LayoutBuilder>
    ),
  },
];

export { publicRoutes, privateRoutes };
